<template>
  <div>
    <button v-on:click.prevent="showModal" v-bind:class="buttonClass">
      {{ computedButtonLabel }}
    </button>
    <modal v-bind:open="open" v-on:close="cancel" v-bind:title="bundle.id_11677">
      <i v-if="loading" style="margin-left: 0.5rem;" class="fa fa-loading-black-16"></i>
      <template v-else="">
        <ul v-if="hasLists" style="margin-bottom: 2rem;" class="new-tabs">
          <li v-bind:class="{'active': !addingNew}">
            <a href="#" v-on:click.prevent="addingNew = false">
              {{ bundle.id_11678 }}
            </a>
          </li>
          <li v-bind:class="{'active': addingNew}">
            <a href="#" v-on:click.prevent="addingNew = true">
              {{ bundle.id_11245 }}
            </a>
          </li>
        </ul>
        <template v-if="!addingNew && hasLists">
          <select-many-checkbox v-bind:id="id + ':existingLists'"
                                v-model="formData.lists"
                                v-bind:errors="formErrors.lists"
                                v-bind:options="computedLists"
                                v-bind:label="bundle.id_11679"
                                v-bind:optional="bundle.id_10054">
          </select-many-checkbox>
        </template>
        <template v-else="">
          <select-one-radio v-if="shareEnabled"
                            name="shareLevel"
                            v-model="formData.shareLevel"
                            v-bind:errors="formErrors.shareLevel"
                            v-bind:options="shareLevels"
                            v-bind:label="bundle.id_11590"
                            v-bind:required="true"/>
          <input-text name="name"
                      v-model="formData.name"
                      v-bind:errors="formErrors.name"
                      v-bind:label="bundle.id_11591"
                      v-bind:placeholder="bundle.id_11592"
                      v-bind:required="true"/>
        </template>
      </template>
      <template v-slot:footer="">
        <button v-if="!loading" type="button"
                v-on:click.prevent="submit()"
                class="btn btn-primary">
          {{ bundle.id_9221 }}
          <i v-if="submitting" style="margin-left: 0.5rem;" class="fa fa-loading-white-12"></i>
        </button>
        <button type="button"
                v-on:click.prevent="cancel()"
                class="btn btn-default">
          {{ bundle.id_9108 }}
        </button>
      </template>
    </modal>
  </div>
</template>

<script>
import Vue from "vue";
import {watchListSecureService} from "@/services/watch-list-secure-service";
import {watchListVatinSecureService} from "@/services/watch-list-vatin-secure-service";

export default {
  name: "add-to-watch-list",
  props: {
    id: {
      type: String,
      required: true
    },
    value: {
      type: String,
      required: true
    },
    portalDomain: {
      type: String,
      required: true
    },
    buttonLabel: {
      type: String,
      required: false
    },
    buttonClass: {
      type: String,
      required: false,
      default: "btn btn-success"
    }
  },
  data: function () {
    return {
      formData: {
        shareLevel: null,
        name: null,
        lists: []
      },
      formErrors: {},
      open: false,
      closeWhenReady: false,
      loading: false,
      submittingList: false,
      submittingListAdds: [],
      submittingListRemovals: [],
      submittingNew: false,
      lists: null,
      addingNew: false,
      bundle: {
        id_11677: "Add to list",
        id_11678: "Existing lists",
        id_11245: "New list",
        id_11679: "Choose lists",
        id_10054: "Optional",
        id_11590: "Sharing",
        id_11591: "Name",
        id_11592: "Enter the name of the list...",
        id_9221: "Ok",
        id_9108: "Cancel",
        id_11690: "Personal",
        id_11618: "Personal list that only I can see.",
        id_11689: "Shared",
        id_11619: "Shared list that everyone in my company can see."
      },
      shareEnabled: !!window.visitor.member,
      shareLevelDefault: "user",
      isAllowed: !!window.visitor.person || (!!window.visitor.ipAccess && window.visitor.ipAccess.enabled)
    }
  },
  created: function () {
    Vue.$bundle("portal", this.bundle, (bundle) => {
      this.bundle = bundle;
    });
  },
  computed: {
    shareLevels: function () {
      return [
        {
          id: "user",
          name: this.bundle.id_11618
        },
        {
          id: "company",
          name: this.bundle.id_11619
        }
      ]
    },
    submitting: function () {
      return this.submittingList || this.submittingListAdds.length > 0 || this.submittingListRemovals.length > 0 || this.submittingNew;
    },
    closeNow: function () {
      var errorCount = 0;
      for (var key in this.formErrors) {
        if (Object.prototype.hasOwnProperty.call(this.formErrors, key)) {
          if (Array.isArray(this.formErrors[key])) {
            errorCount += this.formErrors[key].length;
          }
        }
      }
      return this.closeWhenReady && !this.submitting && errorCount == 0;
    },
    hasLists: function () {
      return this.lists && this.lists.length > 0;
    },
    computedLists: function () {
      var lists = [];
      if (this.lists) {
        for (var i = 0; i < this.lists.length; i++) {
          var list = this.lists[i];
          var set = function (name) {
            list.tags = [{
              name: name,
              styleClass: "badge bg-secondary ms-2"
            }];
          };
          switch (list.shareLevel) {
            case "user":
              set(this.bundle.id_11690);
              break;
            case "company":
              set(this.bundle.id_11689);
              break;
          }
          lists.push(list);
        }
      }
      return lists;
    },
    computedButtonLabel: function () {
      if (this.buttonLabel) {
        return this.buttonLabel;
      }
      return this.bundle.id_11677;
    }
  },
  watch: {
    closeNow: function (newValue/*, oldValue*/) {
      if (newValue == true) {
        this.open = false;
      }
    }
  },
  methods: {
    showModal: function () {
      this.formData.shareLevel = null;
      this.formData.name = null;
      this.formData.lists = [];
      this.formErrors = {};
      this.closeWhenReady = false;
      this.loading = true;
      this.submittingList = false;
      this.submittingListAdds = [];
      this.submittingListRemovals = [];
      this.submittingNew = false;
      this.lists = null;
      this.addingNew = false;

      if (this.isAllowed) {
        watchListSecureService.search({
          first: 0,
          max: 1000
        })
            .then((data) => {
              this.lists = data;
              for (var i = 0; i < this.lists.length; i++) {
                var list = this.lists[i];
                if (list.vatins.indexOf(this.value) != -1) {
                  this.formData.lists.push("" + list.id);
                }
              }
            })
            .catch((err) => {
              console.log(err);
            })
            .finally(() => {
              if (!this.hasLists) {
                this.addingNew = true;
              }
              this.loading = false;
            });
        this.open = true;
      } else {
        window.location = this.portalDomain + "/watch";
      }
    },
    submit: function () {
      this.$clearFormErrors(this.formErrors);
      if (this.addingNew) {
        this.addToNewList();
      } else {
        this.updateLists();
      }
      this.closeWhenReady = true;
    },
    cancel: function () {
      this.open = false;
    },
    addToNewList: function () {
      this.submittingList = true;
      var data = {};
      if (!this.shareEnabled || this.formData.shareLevel) {
        data.shareLevel = this.shareEnabled ? this.formData.shareLevel : this.shareLevelDefault;
      }
      if (this.formData.name) {
        data.name = this.formData.name;
      }
      watchListSecureService.create(data)
          .then((data) => {
            if (data.status === "ok") {
              this.addToList(data.data.id);
            } else {
              this.$showFormErrors(this.formErrors, data.errors);
            }
          })
          .catch((err) => {
            console.log(err);
            this.closeWhenReady = false;
          })
          .finally(() => {
            this.submittingList = false;
          });
    },
    updateLists: function () {
      for (var i = 0; i < this.lists.length; i++) {
        var list = this.lists[i];
        var have = list.vatins.indexOf(this.value) != -1;
        var need = this.formData.lists.indexOf("" + list.id) != -1;
        if (!have && need) {
          this.addToList(list.id);
        }
        if (have && !need) {
          this.removeFromList(list.id);
        }
      }
    },
    addToList: function (watchListId) {
      var data = {
        vatin: this.value
      }
      this.submittingListAdds.push(watchListId);
      watchListVatinSecureService.create(watchListId, data)
          .catch((err) => {
            console.log(err);
            this.closeWhenReady = false;
          })
          .finally(() => {
            var index = this.submittingListAdds.indexOf(watchListId);
            if (index != -1) {
              this.submittingListAdds.splice(index, 1);
            }
          });
    },
    removeFromList: function (watchListId) {
      this.submittingListRemovals.push(watchListId);
      watchListVatinSecureService.remove(watchListId, this.value)
          .catch((err) => {
            console.log(err);
            this.closeWhenReady = false;
          })
          .finally(() => {
            var index = this.submittingListRemovals.indexOf(watchListId);
            if (index != -1) {
              this.submittingListRemovals.splice(index, 1);
            }
          });
    }
  }
}
</script>
